import React, { Component, Fragment } from 'react'

import moment from 'moment'
import {
  DatePicker,
  Layout,
  Breadcrumb,
  Form,
  Input,
  Divider,
  Row,
  Col,
  Avatar,
  Select,
  Switch,
  Tag,
  Icon,
  Button,
  Checkbox,
  message,
  notification,
  Skeleton,
  Popover,
  Radio,
  Tabs,
  InputNumber,
  List,
  Card,
  Spin,
} from 'antd'
import _ from 'lodash'
import $ from 'jquery'
import {
  SearchOutlined,
  CopyOutlined,
  FormOutlined,
  ShopOutlined,
} from '@ant-design/icons'
// import styles from './styles.module.scss';
import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import Errors from 'validatorjs/src/errors'
import ValidatorErrorAlert from '../../components/ValidatorErrorAlert/ValidatorErrorAlert'
import CitySelect from 'components/CitySelect/CitySelect'
import { genFormItemAtrribute } from 'libs/FormHelper'
import { RadioControl, CheckboxControl } from '@wordpress/components'
import { withState } from '@wordpress/compose'
import bannerImage from 'assets/img/banner/banner-catalog.png'
import { store } from '../../reducers'
import { updateAuthInfo } from '../../reducers/auth'
import { UploadOutlined } from '@ant-design/icons'
import WUpload from 'components/WUpload/WUpload'
import { __ } from '@wordpress/i18n'

const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
}
const Option = Select.Option
const { TabPane } = Tabs
const VC_CONFIG = _.get(window, 'VC_CONFIG')
// 前端頁面
export default class UserProfile extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
    isSubmitData: false,
    isLoading: true,
  }

  componentDidMount() {
    AppHelper.updateConfig()

    this.setState({ isFetchData: true, info: this.props.user })

    AppHelper.updateUserInfo(() => {
      this.setState({ isFetchData: false }, () => {
        this.reloadTab()
      })

      this.fillData(this.props.user)
    })
    // 登入換 tokne
    //http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
    // 電子發票列表
    // http://{{hostip}}//api/account/eInvoiceList
    // 點數紀錄 / 消費記錄
    // 密碼變更
    // 查詢編輯會員資料
    // 查詢好康卡會員資料
  }
  reloadTab = () => {
    // tab 共用動態
    var $el, leftPos, newWidth
    /* Add Magic Line markup via JavaScript, because it ain't gonna work without */
    let $magicLine = $('#magic-line')

    if (!_.get($magicLine, 0)) {
      console.log('kkk c', $magicLine)
      $('.basic-tabs-label ul').append("<li id='magic-line'></li>")
    }
    /* Cache it */
    $magicLine = $('#magic-line')

    $magicLine
      .width($('.current_page_item').width())
      .css('left', $('.current_page_item a').position().left)
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width())

    $('.basic-tabs-label ul li a').unbind('mouseenter mouseleave')
    $('.basic-tabs-label ul li')
      .find('a')
      .hover(
        function() {
          $el = $(this)
          console.log('basic-tabs-label', $el)
          leftPos = $el.position().left
          newWidth = $el.parent().width()

          $magicLine.stop().animate({
            left: leftPos,
            width: newWidth,
          })
        },
        function() {
          $magicLine.stop().animate({
            left: $magicLine.data('origLeft'),
            width: $magicLine.data('origWidth'),
          })
        }
      )

    $('#pills-tab .nav-item').unbind('mouseenter mouseleave')
    $('#pills-tab .nav-item')
      .mouseenter(function() {
        if (!$(this).hasClass('highlight')) {
          $('.highlight').removeClass('current_page_item')
        }
      })
      .mouseleave(function() {
        $('.highlight').addClass('current_page_item')
      })
  }
  fillData = (data) => {
    if (!this.formRef.current) return

    // 處理資料，本地適合Form Control的資料
    if (!_.isNil(data.address) || !_.isObject(data.address)) {
      data.address = {
        city_id: _.get(data, 'city_id'),
        area_id: _.get(data, 'area_id'),
      }
    }

    console.log(data)
    this.formRef.current.setFieldsValue(data)
    this.setState({ isLoading: false }, () => {
      this.reloadTab()
    })
  }

  submitData = (info = {}) => {
    console.log('submitData', info)
    this.setState({ isSubmitData: true, messages: {} })

    whttp.post(API_HOST + `/api/account/changePwd`, info, (state, res) => {
      console.log(state, res)
      this.setState({ isSubmitData: false })

      const { code = 100, reason = '發生錯誤', data = {} } = res

      if (state === false) {
        return message.error('發生錯誤')
      }

      if (code !== 200) {
        notification['error']({
          message: '更新失敗',
          description: reason,
        })

        return this.setState({ messages: data.messages || {} })
      }

      message.success('修改成功')
    })
  }

  render() {
    const errors = _.get(this, 'state.validator.errors', new Errors())
    const options = _.get(this, 'props.app.options', {})
    const { info } = this.state
    const Local = _.get(window, 'VC_CONFIG.Locale')
    return (
      <div>
        <main className='bg-light'>
          <div className='container'>
            <section className='pt-2 pb-2'>
              <div className='breadcrumb-wrap'>
                <nav aria-label='breadcrumb'>
                  {Local == 'zh_TW' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                  {Local == 'en_US' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/en`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                </nav>
              </div>
              <h6 className='h5 lh-h4 mb-5 text-navy text-lg-left text-center'>
                {__('親愛的', 'cec-plugin-stores')}{' '}
                <b className='fw-700'>{info && info.cn_name}</b>
                <br className='d-block d-lg-none' />
                {__('您好，歡迎來到會員中心！', 'cec-plugin-stores')}
              </h6>
            </section>
          </div>
          <section className='pt-0'>
            <div className='mb-5 basic-tabs-label'>
              {Local == 'zh_TW' && (
                <ul className='nav nav-pills' id='pills-tab'>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/profile`}>
                      {__('網站帳號', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item current_page_item highlight'>
                    <a className='nav-link'>
                      {__('更改密碼', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/loyaltyprofile`}>
                      {__('好康卡會員資料', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/payment`}
                    >
                      {__('我的消費紀錄', 'cec-plugin-stores')}
                    </a>
                  </li> */}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/point`}>
                      {__('點數紀錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/invoice`}>
                      {__('電子發票記錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/connect`}>
                      {__('第三方登入設定', 'cec-plugin-stores')}
                    </a>
                  </li>
                </ul>
              )}
              {Local == 'en_US' && (
                <ul className='nav nav-pills' id='pills-tab'>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                      {__('網站帳號', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item current_page_item highlight'>
                    <a className='nav-link'>
                      {__('更改密碼', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/loyaltyprofile-en`}>
                      {__('好康卡會員資料', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/payment-en`}>
                      {__('我的消費紀錄', 'cec-plugin-stores')}
                    </a>
                  </li> */}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/point-en`}>
                      {__('點數紀錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/invoice-en`}>
                      {__('電子發票記錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/connect-en`}>
                      {__('第三方登入設定', 'cec-plugin-stores')}
                    </a>
                  </li>
                </ul>
              )}
            </div>
            <div className='container'>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-lg-3 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body pb-0 pt-5 p-lg-5'>
                      <h5 className='h4 text-navy text-center'>
                        {__('會員資料', 'cec-plugin-stores')}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className='col-lg-9 px-3'>
                  <Spin spinning={this.state.isSubmitData}>
                    <Form
                      noStyle
                      ref={this.formRef}
                      name='basic'
                      layout='vertical'
                      onFinish={(values) => this.submitData(values)}
                      onValuesChange={(changedFields, allFields) => {
                        console.log(
                          'onValuesChange:',
                          changedFields,
                          allFields,
                        )
                      }}
                      // onFinishFailed={errorInfo => console.log('onFinishFailed:', errorInfo)}
                      // onFieldsChange={(changedFields, allFields) => {
                      //     const storeInfo = _.reduce(allFields,(obj,item) => {
                      //         _.set(obj, item.name.join('.'), item.value)
                      //         return obj
                      //       }, {})
                      //       console.log('onFieldsChange:', storeInfo, changedFields, allFields)
                      //       return true
                      //     }}
                    >
                      <div className='card border-0 shadow-0 h-100'>
                        <div className='card-body p-5'>
                          <div className='form-group mb-4 row align--items-center'>
                            <label
                              className='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('舊密碼', 'cec-plugin-stores')}
                            </label>
                            <div className='col-sm-10'>
                              <Form.Item
                                rules={[
                                  {
                                    required: true,
                                    message: __(
                                      '請輸入密碼!',
                                      'cec-plugin-stores',
                                    ),
                                  },
                                ]}
                                {...genFormItemAtrribute('opw')}>
                                <Input.Password />
                              </Form.Item>
                            </div>
                          </div>
                          <div className='form-group mb-4 row align--items-center'>
                            <label
                              className='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('新密碼', 'cec-plugin-stores')}
                            </label>
                            <div className='col-sm-10'>
                              <Form.Item
                                rules={[
                                  {
                                    required: true,
                                    message: __(
                                      '請輸入新密碼!',
                                      'cec-plugin-stores',
                                    ),
                                  },
                                ]}
                                {...genFormItemAtrribute('npw')}>
                                <Input.Password />
                              </Form.Item>
                            </div>
                          </div>
                          <div className='form-group mb-4 row align--items-center'>
                            <label
                              className='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('再次輸入', 'cec-plugin-stores')}
                            </label>
                            <div className='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('npw_chk')}
                                dependencies={['npw']}
                                rules={[
                                  {
                                    required: true,
                                    message: __(
                                      '請輸入確認密碼!',
                                      'cec-plugin-stores',
                                    ),
                                  },
                                  ({ getFieldValue }) => ({
                                    validator(rule, value) {
                                      if (
                                        !value ||
                                        getFieldValue('npw') === value
                                      ) {
                                        return Promise.resolve()
                                      }
                                      return Promise.reject(
                                        __(
                                          '再次輸入密碼不同!',
                                          'cec-plugin-stores',
                                        ),
                                      )
                                    },
                                  }),
                                ]}>
                                <Input.Password />
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </Spin>
                </div>
              </div>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-lg-3 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'>
                      <h5 className='h4 text-navy text-center'>
                        {__('注意事項', 'cec-plugin-stores')}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className='col-lg-9 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確 性。客服中心：市話 0809-001-365 / 手機(02)8006-9999 ※ 由於促銷目錄為提前印製，故於 網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！ ※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。',
                          'cec-plugin-stores',
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='text-center mt-5'>
                <a
                  className='h6 btn btn-outline-primary rounded-pill px-5 py-4'
                  role='button'
                  href='#'
                  onClick={(e) => {
                    e.preventDefault()
                    this.formRef.current.submit()
                  }}>
                  {__('確定修改', 'cec-plugin-stores')}
                </a>
              </div>
            </div>
          </section>
        </main>
      </div>
    )
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }
export class UserPasswordEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount() {
    AppHelper.updateConfig()
    console.log('kkk', this.props.attributes)

    this.formRef.current.setFieldsValue(this.props.attributes)
  }
  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    console.log('editor', this.props)

    return (
      <div className='wp-block-cec-vulcan-block-catalogue-list-editor'>
        <h2>會員變更密碼模組</h2>
        <Form ref={this.formRef} name='basic' className='basicForm' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-password.js